//电站列表
export const SELECT_DEVICE_TYPE='home/devicetypelist/SELECT_DEVICE_TYPE';

export const GET_DEVICE_TYPE_LIST='home/devicetypelist/GET_DEVICE_TYPE_LIST';

export const SET_DEVICE_TYPE_LIST='home/devicetypelist/SET_DEVICE_TYPE_LIST';